/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Select_Event_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Please select an Event" |
*
* @param {Notes_Select_Event_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_select_event_placeholder = /** @type {((inputs?: Notes_Select_Event_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Select_Event_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Veranstaltung aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите мероприятие.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor seleccione un evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择一项活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक कार्यक्रम चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione um evento.")
	return /** @type {LocalizedString} */ ("Please select an Event")
});